import React, { useEffect } from "react";
import { useSelector } from "react-redux";

function MainButton(data, buttonsIndex, index) {
  return (
    <div className="taxi-block text-base sm:text-lg md:text-xl cursor-pointer  taxi-block-background Primary_Dark_Text">
      <div className="bg-gradient-to-t from-gray-100 p-3  rounded-full ">
        <img
          src={data.data.imageUrl}
          className={
            buttonsIndex === index
              ? "w-8 sm:w-10 md:w-12  "
              : "w-8 sm:w-10 md:w-12 "
          }
        />
      </div>

      <div className="taxi-destination text-white">{data.data.name}</div>
    </div>
  );
}

export default MainButton;
